import { Role } from '../models/role'
import { RouteConfig } from 'vue-router'

import homeIcon from '@/assets/images/icon_menu_workbench@2x.png'
import homeIconActive from '@/assets/images/icon_menu_workbench_active@2x.png'

const Home = () => import('../views/HomeOrganization.vue')

export const homeRoute: RouteConfig = {
  path: '/organization/home',
  name: 'organization_home',
  component: Home,
  meta: {
    title: '概览',
    icon: homeIcon,
    iconActive: homeIconActive,
    showMenu: false,
    roles: [Role.Offical],
  },
}

export default [homeRoute]
